import React from "react";

const About = () => {
  return (
    <div>
      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>About Us</h2>
                <ul className="bread-list">
                  <li><a href="/">Home</a></li>
                  <li><i className="icofont-simple-right"></i></li>
                  <li className="active">About Us</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Breadcrumbs */}

      {/* Start About Us Section */}
      <section className="why-choose section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                {/* Optional Title Content */}
              </div>
            </div>
          </div>
          <div className="row">
            {/* Left Column: About Information */}
            <div className="col-lg-6 col-12">
  <div className="choose-left">
    <h3>Who We Are</h3>
    <p>
      We are dedicated professionals specializing in senior investor affairs, bringing a strong background in Real Estate and HR management. Our mission in financial assistance stems from firsthand experience—understanding the challenges many families face in securing adequate financial resources for retirement after years of hard work and entrepreneurship.
    </p>
    <p>
      Those who seek our guidance gain substantial benefits, including:
    </p>
    <ul>
      <li>Up to a <strong>50% reduction in tax liabilities</strong></li>
      <li>Elimination of taxes on social security income</li>
      <li>Augmentation of fixed monthly income</li>
      <li>Enhanced safeguards for financial well-being</li>
    </ul>
    <p>
      Committed to promoting financial literacy, we actively conduct seminars and webinars both locally and nationally. We serve communities such as <strong>Contra Costa, Silicon Valley, Marin, and Santa Rosa</strong>, while also extending our reach to <strong>Arizona, Washington, Florida, Texas, and South Carolina</strong>.
    </p>
    <p>
      Our mission aligns with the principle of <em>“no family left behind”</em>, reflecting our unwavering dedication to ensuring comprehensive financial well-being for all.
    </p>



                <div className="row">
                  <div className="col-lg-6">
                    <ul className="list">
                      <li><i className="fa fa-caret-right"></i> FINANCIAL STRATEGIES </li>
                      <li><i className="fa fa-caret-right"></i> PROPER PROTECTION</li>
                      <li><i className="fa fa-caret-right"></i> EMERGENCY FUND</li>
                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <ul className="list">
                      <li><i className="fa fa-caret-right"></i> DEBT MANAGEMENT </li>
                      <li><i className="fa fa-caret-right"></i> BUILD WEALTH</li>
                      <li><i className="fa fa-caret-right"></i> PRESERVE WEALTH</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="col-lg-6 col-md-12">
              <div className="appointment-image1">
                <img src="img/logo2.jpg" alt="Charlotte Enriquez" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End About Us Section */}
    </div>
  );
};

export default About;
